import React from "react";
import aboutOne from "../assets/images/aboutOne.png";
import aboutTwo from "../assets/images/aboutTwo.png";
import "./About.css";

export default function About() {
  return (
    <div className="about_main">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-2 col-md-2 col-sm-12 col-12">
            <div className="about_img">
              <img src={aboutOne} alt="Carpet" />
            </div>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-12 col-12">
            <div className="about_mid">
              <div className="about_title">
                <h3>About Us</h3>
              </div>
              <div className="about_desc">
                <p>
                  Indulge in the timeless elegance of thoughtfully crafted home
                  textiles designed to elevate every corner of your living
                  space. Our collection brings together premium fabrics, refined
                  textures, and sophisticated designs that seamlessly blend
                  comfort with style.{" "}
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-5 col-sm-12 col-12">
            <div className="about_end">
              <div className="about_desc">
                <p>
                  Indulge in the timeless elegance of thoughtfully crafted home
                  textiles designed to elevate every corner of your living
                  space. Our collection brings together premium fabrics, refined
                  textures, and sophisticated designs that seamlessly blend
                  comfort with style.
                </p>
                <a href="#" className="more_btn">Read More</a>
                <div className="about_two_img">
                    <img src={aboutTwo} alt="Carpet" />
                </div>
                 
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
